import type { Nullable } from './types'

/**
 * Represents a general exception that can be thrown upon a fetch request.
 * Extends the built-in Error class.
 *
 * @see ValidationException
 */
export class RequestException extends Error {
  static readonly __brand: unique symbol = Symbol('RequestException')
  public response?: Response
  public context?: any

  /**
   * Constructs a new RequestException.
   *
   * @param {any} data - The data containing the error details.
   * @param {any} context - The context in which the error occurred.
   * @param {Response} [res] - Optional response object.
   */
  constructor(data: any, context?: any, res?: Nullable<Response>) {
    if (res) {
      super(res.statusText)

      this.response = res.clone()
    } else {
      super('Request Exception')
    }

    this.name = 'RequestException'

    // Error.captureStackTrace(this, RequestException)

    this.context = context
    this.message = data?.message ?? data ?? 'Unknown Error'
  }

  get status(): number | undefined {
    return this.response?.status
  }
}
